var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("video.on-client-disconnected"),
          okFn: function() {}
        },
        model: {
          value: _vm.reconnectDialogVisible,
          callback: function($$v) {
            _vm.reconnectDialogVisible = $$v
          },
          expression: "reconnectDialogVisible"
        }
      }),
      _vm._v(" "),
      !_vm.loaded
        ? _c("div", [
            _c(
              "div",
              { staticClass: "preload-block" },
              [
                _c("loading-anim", {
                  attrs: {
                    active: !_vm.loaded,
                    fullScreen: "",
                    text: _vm.$t("loading-videosession")
                  }
                })
              ],
              1
            )
          ])
        : _c(
            "div",
            { attrs: { id: "videoTemplate" } },
            [
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "preconnecting",
                    centered: "",
                    "cancel-disabled": "",
                    "no-close-on-esc": "",
                    "no-close-on-backdrop": "",
                    "hide-header-close": "",
                    title: _vm.userIsProfessional
                      ? _vm.$t("video.connecting")
                      : _vm.$t("waitingProfessionalHeader")
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-footer",
                      fn: function() {
                        return [_c("support-chat-button")]
                      },
                      proxy: true
                    }
                  ]),
                  model: {
                    value: _vm.preconnecting,
                    callback: function($$v) {
                      _vm.preconnecting = $$v
                    },
                    expression: "preconnecting"
                  }
                },
                [
                  _vm.connectivityErrors
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "mx-auto",
                            staticStyle: {
                              width: "96px",
                              margin: "20px 0 40px 0"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                width: "96px",
                                height: "96px",
                                alt: "danger",
                                src:
                                  "/static-appopensalud/img/icons/danger-icon.svg"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.otLoggingError
                          ? _c("div", [
                              _c(
                                "p",
                                { staticClass: "text-danger text-center" },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.$t("video-test.adblock-error"))
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _c("div", [
                              _c(
                                "p",
                                { staticClass: "text-danger text-center" },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dialog-title-minimumRequisitesVideoTest"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "text-danger errorPanel" },
                                [
                                  _c("small", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("test-requisites")) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            ])
                      ])
                    : _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "mx-auto",
                            staticStyle: {
                              width: "96px",
                              margin: "20px 0 40px 0"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                width: "96px",
                                height: "96px",
                                src:
                                  "/static-appopensalud/img/icons/clock-icon-blue-fill.svg"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.videoStarted
                          ? _c(
                              "p",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.userIsProfessional
                                      ? _vm.$t("video.wait-connecting-patient")
                                      : _vm.$t("waitingProfessionalBody")
                                  )
                                )
                              ]
                            )
                          : _c(
                              "p",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("reconnectingProfessional"))
                                )
                              ]
                            )
                      ])
                ]
              ),
              _vm._v(" "),
              _c("base-dialog", {
                attrs: {
                  visible: _vm.preHangUpState,
                  okFn: function() {
                    _vm.hangUp()
                  },
                  content: _vm.$t("video.hang-up-are-you-sure-question")
                },
                on: {
                  toggle: function($event) {
                    _vm.preHangUpState = !_vm.preHangUpState
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "sessionEnded-modal",
                    centered: "",
                    "cancel-disabled": "",
                    "no-close-on-esc": "",
                    "no-close-on-backdrop": "",
                    "hide-header-close": "",
                    "hide-footer": "",
                    title: _vm.$t("sessionEnded")
                  },
                  model: {
                    value: _vm.patientSessionEnded,
                    callback: function($$v) {
                      _vm.patientSessionEnded = $$v
                    },
                    expression: "patientSessionEnded"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "mx-auto",
                      staticStyle: { width: "96px", margin: "20px 0 40px 0" }
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "96px",
                          height: "96px",
                          src:
                            "/static-appopensalud/img/icons/hangup-sessionend-icon-blue-fill.svg"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    staticStyle: { "text-align": "center" },
                    domProps: { innerHTML: _vm._s(_vm.$t("sessionEndedBody")) }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "text-align": "center" } },
                    [
                      _vm.appointment && _vm.appointment.portal
                        ? _c(
                            "base-button",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.returnToWebapp()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("dialog.ok-button"))
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm.errorName
                ? _c("error", { attrs: { customError: _vm.errorName } })
                : _c(
                    "div",
                    { attrs: { id: "videoTemplate" } },
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: {
                            id: "sessionEnded-modal",
                            centered: "",
                            "cancel-disabled": "",
                            "no-close-on-esc": "",
                            "no-close-on-backdrop": "",
                            "hide-header-close": "",
                            "hide-footer": "",
                            title: _vm.$t("sessionEnded")
                          },
                          model: {
                            value: _vm.sessionEnded,
                            callback: function($$v) {
                              _vm.sessionEnded = $$v
                            },
                            expression: "sessionEnded"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "mx-auto",
                              staticStyle: {
                                width: "96px",
                                margin: "20px 0 40px 0"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "96px",
                                  height: "96px",
                                  src:
                                    "/static-appopensalud/img/icons/hangup-sessionend-icon-blue-fill.svg"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", {
                            staticStyle: { "text-align": "center" },
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("sessionEndedBody"))
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _vm.appointment && _vm.appointment.portal
                                ? _c(
                                    "base-button",
                                    {
                                      staticStyle: { "text-align": "center" },
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.returnToWebapp()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("dialog.ok-button"))
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.preconnecting,
                              expression: "!preconnecting"
                            }
                          ],
                          attrs: { id: "video" }
                        },
                        [
                          _c("div", { attrs: { id: "subscriber" } }),
                          _vm._v(" "),
                          _c("div", { attrs: { id: "publisher" } }),
                          _vm._v(" "),
                          !_vm.preconnecting &&
                          !_vm.sessionEnded &&
                          _vm.appointment
                            ? _c("timer", {
                                ref: "timer",
                                attrs: {
                                  id: "timer",
                                  id: _vm.appointment.id,
                                  duration: _vm.appointment.duration,
                                  startTime: _vm.videoSession.videoSessionStart,
                                  videoTooltip: ""
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.preconnecting
                            ? _c(
                                "div",
                                { attrs: { id: "video-toolbar" } },
                                [
                                  _c("slashable-icon", {
                                    attrs: {
                                      img:
                                        "/static-appopensalud/img/icons/camera-icon-blue-fill.svg",
                                      popover: !_vm.camShared
                                        ? _vm.$t("enable-cam")
                                        : _vm.$t("disable-cam"),
                                      slashed: !_vm.camShared
                                    },
                                    on: { click: _vm.toggleCamera }
                                  }),
                                  _vm._v(" "),
                                  _c("slashable-icon", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    attrs: {
                                      img:
                                        "/static-appopensalud/img/icons/mic-icon-blue-fill.svg",
                                      popover: _vm.muted
                                        ? _vm.$t("enable-mic")
                                        : _vm.$t("mute-mic"),
                                      slashed: _vm.muted
                                    },
                                    on: { click: _vm.toggleMute }
                                  }),
                                  _vm._v(" "),
                                  _c("slashable-icon", {
                                    staticClass: "d-none d-xl-inline-block",
                                    attrs: {
                                      img:
                                        "/static-appopensalud/img/icons/screen-icon-blue-fill.svg",
                                      popover: _vm.screenShared
                                        ? _vm.$t("stop-share-screen")
                                        : _vm.$t("share-screen"),
                                      slashed: _vm.screenShared
                                    },
                                    on: { click: _vm.toggleScreenShare }
                                  }),
                                  _vm._v(" "),
                                  _vm.userIsProfessional
                                    ? _c("div", [
                                        _c("img", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass:
                                            "rounded-btn toggled-red-btn",
                                          attrs: {
                                            src:
                                              "/static-appopensalud/img/icons/hangup-icon-red-fill.svg",
                                            title: _vm.$t("hang-up-video")
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.preHangUpState = true
                                            }
                                          }
                                        })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("img", {
                                      staticClass:
                                        "rounded-btn d-none d-xl-inline-block",
                                      staticStyle: {
                                        "background-color": "rgb(78, 140, 255)",
                                        cursor: "pointer"
                                      },
                                      attrs: {
                                        src:
                                          "/static-appopensalud/img/icons/refresh-icon-blue-fill.svg",
                                        title: _vm.$t("refresh-label")
                                      },
                                      on: { click: _vm.refresh }
                                    })
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.preconnecting
                        ? _c("beautiful-chat", {
                            attrs: {
                              participants: _vm.chat.participants,
                              titleImageUrl: _vm.chat.titleImageUrl,
                              onMessageWasSent: _vm.sendMessage,
                              messageList: _vm.chat.messageList,
                              newMessagesCount: _vm.chat.newMessagesCount,
                              isOpen: _vm.chat.isChatOpen,
                              icons: _vm.chat.icons,
                              open: _vm.openChat,
                              showEmoji: false,
                              showEdition: false,
                              showDeletion: false,
                              close: _vm.closeChat,
                              showFile: true,
                              showTypingIndicator: _vm.chat.showTypingIndicator,
                              showLauncher: true,
                              showCloseButton: true,
                              colors: _vm.chat.colors,
                              alwaysScrollToBottom:
                                _vm.chat.alwaysScrollToBottom,
                              messageStyling: _vm.chat.messageStyling,
                              placeholder: _vm.$t("chat-placeholder")
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function() {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "sc-header--title enabled"
                                        },
                                        [_vm._v("Chat")]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              3990056774
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$apiToken && !_vm.preconnecting
                        ? _c("video-sidebar", {
                            on: {
                              "source-device-changed": _vm.changeSourceDevices
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("CoolLightBox", {
                        attrs: {
                          items: _vm.lightbox.items,
                          index: _vm.lightbox.index
                        },
                        on: {
                          close: function($event) {
                            return _vm.$store.commit("video/resetLightbox")
                          }
                        }
                      })
                    ],
                    1
                  )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f003dce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f003dce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-launcher/Video.vue
// module id = 3644
// module chunks = 29